import { createAction, handleActions } from "redux-actions";

import { createPromiseActionTypes } from "../utils/redux";
import Api from "../services/Api";

// TYPES
export const VIDEOS_GET = createPromiseActionTypes("models/VIDEOS_GET");

// ACTIONS
const getVideosPendingAction = createAction(VIDEOS_GET.PENDING);
const getVideosFulfilledAction = createAction(VIDEOS_GET.FULFILLED);
const getVideosRejectedAction = createAction(VIDEOS_GET.REJECTED);

export const getVideosAction = () => async (dispatch, getState) => {
  dispatch(getVideosPendingAction());

  const state = getState();

  const cityId = state.intl.cityId;
  const genderId = state.booking.genderId;

  try {
    const payload = await Api.getVideos(cityId, genderId);
    dispatch(getVideosFulfilledAction(payload));
  } catch (err) {
    dispatch(getVideosRejectedAction(err));
  }
};

// REDUCER
const initialState = {
  byId: {},
  result: [],
};

export default handleActions(
  {
    [VIDEOS_GET.FULFILLED]: getVideosFullfilled,
  },
  initialState
);

// CONTROLLERS
function getVideosFullfilled(state, { payload }) {
  const { entities, result } = payload;

  const byId = Object.assign({}, state.byId, entities.videos);

  return {
    ...state,
    byId,
    result,
  };
}
